import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'

import useDrawerFormClasses from '../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const MetricsSectionSkeleton = ({ title }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormClasses()

  const { t } = useTranslation()
  return (
    <section className={drawerFormClasses.section}>
      <div className={classes.sectionHeader}>
        <h3 className={classes.sectionTitle}>{t(title)}</h3>
      </div>
      <p>
        <Skeleton width={240} />
      </p>
      <Skeleton width="50%" count={3} style={{ marginTop: '16px' }} />
    </section>
  )
}

MetricsSectionSkeleton.propTypes = {
  title: PropTypes.string.isRequired
}

export default MetricsSectionSkeleton
